import type { PanelSpec } from "../types";

export interface PanelRect { spec: PanelSpec; top: number; bottom: number }

export interface Layout {
  w: number; h: number;
  rightAxis: number; bottomAxis: number;
  plotLeft: number; plotRight: number; plotW: number;
  plotTop: number; priceBottom: number; priceH: number;
  panels: PanelRect[];
}

const PANEL_H = 92;
const PANEL_GAP = 6;

export function computeLayout(w: number, h: number, panels: PanelSpec[]): Layout {
  const rightAxis = 66, bottomAxis = 22, plotLeft = 8, plotTop = 8;
  const plotRight = w - rightAxis;
  const panelsH = panels.reduce((s, p) => s + (p.height ?? PANEL_H) + PANEL_GAP, 0);
  const priceBottom = h - bottomAxis - panelsH;
  let cursor = priceBottom + PANEL_GAP;
  const rects: PanelRect[] = panels.map((spec) => {
    const top = cursor;
    const bottom = top + (spec.height ?? PANEL_H) - PANEL_GAP;
    cursor += (spec.height ?? PANEL_H) + PANEL_GAP;
    return { spec, top, bottom };
  });
  return { w, h, rightAxis, bottomAxis, plotLeft, plotRight, plotW: plotRight - plotLeft, plotTop, priceBottom, priceH: priceBottom - plotTop, panels: rects };
}
